// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

// Ajuster la taille du top post
function adjustImageHeight() {
    const coverInformations = document.querySelector(".cover__informations");
    const coverImageWrapper = document.querySelector(".cover__image-wrapper");
    const coverTitle = document.querySelector(".cover__title");

    if (coverInformations) {
        if (!coverImageWrapper) {
            coverInformations.style.minHeight = "unset";
            coverTitle.classList.add('hidden-before');
        }
    }
}

window.addEventListener("resize", adjustImageHeight);

adjustImageHeight();